const qtype = window.question_type;
export const STATIC_TEXT = {
  HFS_VALULT_SURVEY: 'Vault Survey',
  SELECT_OPTION: 'Select Option',
  SELECT_OPTION_TO_DOWNLOAD_YOUR_SURVEY: 'Select option to download your survey ',
  SELECT_OPTION_TO_CONTINUE_WITH_THE_SURVEY: 'Select option to continue with the survey.',
  HFS_SURVEY_VAULT: 'Survey Vault',
  HFS_SURVEY_INSIGHTS: 'Survey Insights',
  HFS_SURVEY_INSIGHT: 'Survey Insight',
  NEXT: 'Next',
  CANCEL: 'Cancel',
  QUICK_SURVEY_QUESTIONNAIRE: 'Quick Survey Questionnaire',
  DOWNLOAD_SURVEY: 'download survey',
  DOWNLOAD: 'Download',
  YOUR_FILE_OF_SURVEY_WILL_BE_DOWNLOAD_IN_THE_EXCEL_FORMAT:
    'Your File of survey will download in the excel format.',
  YOUR_FILE_OF_SURVEY_WILL_BE_DOWNLOAD_IN_THE_WORD_FORMAT:
    'Your File of survey will download in the word format.',
  MANAGE_ACCOUNT: 'Manage account',
  PROFILE_SUBHEADING: 'Change you first name, last name or password',
  MANAGE_QUESTIONS: 'Manage Questions'
};

// export const QUESTION_TYPE = [
//   'Single select',
//   'Multiple select',
//   'Rank',
//   'Hidden',
//   'Open text response',
//   'Grid',
//   ''
// ];
export const QUESTION_TYPE = qtype;

export const NEXT_BUTTON = 'Next';
